// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-navigation"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M12.9999 12L10.0002 20.9989L7.93799 17.0619L4.00098 14.9996L12.9999 12Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 6L3 6M19 20V3M21 16H17M7 3V10","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.9999 12L10.0002 20.9989L7.93799 17.0619L4.00098 14.9996L12.9999 12Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-navigation')
export default class MapNavigationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-navigation',
    }
  }
}
